import { Component, Input, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { PAGE_FIX_SELECTOR_QUERIES } from '@client/app/modules/page-fix/constants/page-fix-selector-queries';
import { PAGE_FIX_FIXABLE_TYPES } from '@client/app/modules/page-fix/constants/page-fix-fixable-types';
import { PAGE_FIX_CHANGE_TYPES } from '@client/app/modules/page-fix/constants/page-fix-change-types';
import { PAGE_FIX_EVENT } from '@client/app/modules/page-fix/constants/page-fix-event';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { PageFixFormBoldOptionService } from './service/options.service';

@Component({
    selector: 'page-fix-form-bold-options',
    templateUrl: './page-fix-form-bold-options.component.html',
    standalone: false,
})
export class PageFixFormBoldOptionsComponent implements OnInit, OnDestroy {
    @Input() monPageFix?: any;
    @Input() monPageFixId!: number;
    @Input() monPageFixSelector!: string;
    @Input() monType!: string;
    @Input() monSelected!: boolean;
    @Input() monOrder!: number;

    elementOptions: any[] = [];
    replacementRegex!: RegExp;
    elementReplacement: string = 'strong';
    customElement: string = '';
    replacementSetting: number = 0;
    requestPreparePayloadId: number = 0;
    previewText: string = '';

    constructor (
        private monEventService: MonEventService,
        private elementRef: ElementRef,
        private pageFixFormBoldOptionService: PageFixFormBoldOptionService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    ngOnDestroy (): void {
        this.onDestroy();
    }

    private activate (): void {
        this.elementOptions = this.pageFixFormBoldOptionService.getElementOptions();
        this.replacementRegex = this.pageFixFormBoldOptionService.getElementRegex();
        this.elementReplacement = 'strong';
        this.customElement = '';
        this.replacementSetting = 0;
        this.requestPreparePayloadId = 0;
        this.previewText = '';

        this.monEventService.run(PAGE_FIX_EVENT.REGISTER_VIEW, this.elementRef.nativeElement, {
            type: this.monType,
            order: this.monOrder,
            selected: this.monSelected,
        });

        if (this.monPageFix) {
            const changeValue = this.monPageFix.change.value;
            if (this.elementOptions.find(option => option.value === changeValue)) {
                this.elementReplacement = changeValue;
            } else {
                this.customElement = changeValue;
                this.replacementSetting = 1;
            }
        }

        this.setupListeners();
    }

    private onDestroy (): void {
        this.monEventService.run(PAGE_FIX_EVENT.UNREGISTER_VIEW, this.elementRef.nativeElement);
        this.monEventService.remove(this.requestPreparePayloadId);
    }

    getElementText (): string {
        if (this.replacementSetting === 0) {
            return this.elementReplacement;
        }
        return this.customElement;
    }

    updatePreview (): void {
        setTimeout(() => {
            const elementName = this.getElementText();
            const valid = this.pageFixFormBoldOptionService.isElementNameValid(elementName);
            this.monEventService.run(PAGE_FIX_EVENT.CUSTOM_VALIDATION, valid);
            this.setPreview(elementName);
        });
    }

    setReplacementSetting (setting: number): void {
        this.replacementSetting = setting;
        this.updatePreview();
    }

    private setPreview (elementName: string): void {
        this.previewText = this.pageFixFormBoldOptionService.getElementPreview(elementName);
    }

    private setupListeners (): void {
        this.requestPreparePayloadId = this.monEventService.addListener(PAGE_FIX_EVENT.REQUEST_PREPARE_PAYLOAD, () => {
            const payload: any = {
                change: {
                    attribute: 'b',
                    check_id: this.monPageFixId,
                    value: this.getElementText(),
                },
            };
            if (!this.monPageFix) {
                payload.selector = PAGE_FIX_SELECTOR_QUERIES.query_selector + ';' + this.monPageFixSelector;
                payload.fixable_type = PAGE_FIX_FIXABLE_TYPES.accessibility_check;
                payload.fixable_id = this.monPageFixId;
                payload.change_type = PAGE_FIX_CHANGE_TYPES.element + ':b';
            }
            this.monEventService.run(PAGE_FIX_EVENT.REQUEST_SUBMIT, payload);
        });
    }
}
